import { PublicationStatusInfoExtended } from '@/models/common/publication-status-info';
import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';
import { BusinessOpeningHours } from './business-opening-hours';

export class BusinessFrontPageSummary {
    public businessId: number = 0;
    public publicationStatus: PublicationStatusInfoExtended[] = [];
    public hasClaim: boolean = false;
    public hasSubclaim: boolean = false;
    public hasDescription: boolean = false;
    public hasContactName: boolean = false;
    public hasContactPhone: boolean = false;
    public hasContactEmail: boolean = false;
    public hasContactWebsite: boolean = false;
    public slug?: string;
    public isSlugOperational: boolean | null = null;
    public hasContactAddress: boolean = false;
    public openingHours: BusinessOpeningHours = new BusinessOpeningHours();
    public mainImageUrl: string = '';
    public hasOtherLinks: boolean = false;

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.Businesses;
    }

    public get permissionsIdToCheck(): number {
        return this.businessId;
    }

    get hasImage(): boolean {
        if (this.mainImageUrl) {
            return true;
        }

        return false;
    }

    get hasSlug(): boolean {
        return this.slug ? true : false;
    }

    get hasAtLeastOneFrontPagePublished(): boolean {
        return this.publicationStatus.some(p => p.isPublished);
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        const imagesContextShared = require.context('@/assets/placeholders/shared/', false, /(\.jpg|\.png)$/);

        Object.assign(
            this,
            json,
            { publicationStatus: json.publicationStatus ? json.publicationStatus.map((status: any) => new PublicationStatusInfoExtended(status)) : [] },
            { openingHours: json.openingHours ? new BusinessOpeningHours(json.openingHours) : new BusinessOpeningHours() }
        );
    }
}
